import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { InsertDriveFile, PlayArrow } from "@mui/icons-material";
import { alpha } from "@mui/material";

export interface VideoThumbnailProps {
  thumbnail: string | null;
  duration: string;
  onClick: () => void;
}

export const VideoThumbnail: FC<VideoThumbnailProps> = ({
  thumbnail,
  duration,
  onClick,
}) => {
  return (
    <Box
      sx={{
        mt: 1,
        position: "relative",
        borderRadius: 1,
        overflow: "hidden",
        cursor: "pointer",
        height: 64,
        "&:hover": {
          "& .overlay": {
            bgcolor: alpha("#000", 0.6),
          },
          "& .play-button": {
            transform: "scale(1.1)",
          },
        },
      }}
      onClick={onClick}
    >
      {thumbnail ? (
        <Box
          component="img"
          src={thumbnail}
          alt="Video thumbnail"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            bgcolor: "action.hover",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <InsertDriveFile sx={{ color: "text.secondary" }} />
        </Box>
      )}

      <Box
        className="overlay"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: alpha("#000", 0.5),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
        }}
      >
        <Box
          className="play-button"
          sx={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            bgcolor: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s ease",
            boxShadow: 2,
          }}
        >
          <PlayArrow sx={{ color: "white" }} />
        </Box>

        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            bottom: 4,
            right: 8,
            color: "white",
            bgcolor: alpha("#000", 0.6),
            px: 0.5,
            borderRadius: 0.5,
          }}
        >
          {duration}
        </Typography>
      </Box>
    </Box>
  );
};

export default VideoThumbnail;
